export default "__VITE_ASSET__a7d0792f__"